/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Planet(props) {
  const { nodes, materials } = useGLTF('/kai_planet.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_0.geometry}
        material={materials.object_0}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_11.geometry}
        material={materials.object_11}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_12.geometry}
        material={materials.object_12}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_13.geometry}
        material={materials.object_13}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_14.geometry}
        material={materials.object_14}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_2.geometry}
        material={materials.object_2}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_3.geometry}
        material={materials.object_3}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_4.geometry}
        material={materials.object_4}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_6.geometry}
        material={materials.object_6}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_7.geometry}
        material={materials.object_7}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_8.geometry}
        material={materials.object_8}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.object_9.geometry}
        material={materials.object_9}
      />
    </group>
  )
}

useGLTF.preload('/kai_planet.glb')